import React from 'react';
import styled from 'styled-components';
import { IconWrapper, SvgIcon } from '../../../Icon';
import { ContentSplitResult } from '../useContentSplit';
import { theme } from '../../../../styles/theme';
import {
  SingleSelect,
  SingleSelectOption,
} from '../../../Dropdown/SingleSelect';

const StyledIconWrapper = styled(IconWrapper)`
  &:hover,
  &[aria-expanded='true'] {
    border-radius: 4px;
    background-color: ${theme.colors.blue500};
  }
`;

export type ContentType =
  | 'richText'
  | 'image'
  | 'report'
  | 'dashboard'
  | 'cohort';

interface Props {
  onAdd: (type: ContentType, split?: ContentSplitResult) => void;
}

const AddScratchpadContent = ({ onAdd }: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleSelect = (type: ContentType) => {
    onAdd(type);
  };

  return (
    <SingleSelect
      trigger={
        <StyledIconWrapper onClick={handleClick} size={24}>
          <SvgIcon
            name="plus"
            width={18}
            height={18}
            customFill="currentColor"
          />
        </StyledIconWrapper>
      }
      menuMinWidth={200}
    >
      <SingleSelectOption
        iconName="image"
        label={'Add Image'}
        onClick={() => handleSelect('image')}
      />
      <SingleSelectOption
        iconName="chart-line"
        label={'Add Report'}
        onClick={() => handleSelect('report')}
      />
      <SingleSelectOption
        iconName="dashboard"
        label={'Add Dashboard'}
        onClick={() => handleSelect('dashboard')}
      />
      <SingleSelectOption
        iconName="users-three"
        label={'Add Cohort'}
        onClick={() => handleSelect('cohort')}
      />
    </SingleSelect>
  );
};

export default AddScratchpadContent;
